module.exports = __webpack_public_path__ + "img/logo_biotopia_row_color.b8b95139.png";